import { useState } from 'react';

/**
 * Open-ended text input for Menti participants.
 * Textarea with character counter and submit button.
 *
 * @param {Object} props
 * @param {Object} props.slide - Slide data with config.maxLength
 * @param {function} props.onSubmit - Called with the text string
 * @param {boolean} props.loading
 */
export default function OpenEndedInput({ slide, onSubmit, loading }) {
  const [text, setText] = useState('');
  const maxLength = slide.config?.maxLength || 200;

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = text.trim();
    if (!trimmed || loading) return;
    onSubmit(trimmed);
  };

  return (
    <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-6 border border-white/15">
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <label className="sr-only" htmlFor="openended-input">Ditt svar</label>
        <textarea
          id="openended-input"
          value={text}
          onChange={(e) => {
            if (e.target.value.length <= maxLength) {
              setText(e.target.value);
            }
          }}
          placeholder="Skriv svaret ditt her..."
          rows={4}
          className="block w-full bg-white text-gray-900 placeholder:text-gray-400 rounded-2xl border-0 focus:ring-4 focus:ring-blue-300/30 text-lg font-medium p-4 shadow-inner transition-all duration-200 resize-none"
          disabled={loading}
          autoFocus
        />

        <div className="flex items-center justify-between">
          <span className={`text-sm ${text.length >= maxLength ? 'text-red-300 font-medium' : 'text-white/50'}`}>
            {text.length}/{maxLength} teikn
          </span>
        </div>

        <button
          type="submit"
          disabled={!text.trim() || loading}
          className="w-full h-12 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-lg font-bold rounded-full shadow-lg hover:shadow-xl hover:-translate-y-0.5 hover:brightness-110 active:translate-y-0 transition-all duration-200 disabled:opacity-40 disabled:hover:translate-y-0 disabled:hover:shadow-lg flex items-center justify-center gap-2"
        >
          {loading ? (
            <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
          ) : (
            <>
              <span>Send svar</span>
              <span className="material-symbols-outlined text-xl">send</span>
            </>
          )}
        </button>
      </form>
    </div>
  );
}
